import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BackgroundVideo from "./components/BackgroundVideo/BackgroundVideo.component";
import RootPage from "./pages/root/root.page";
import { AuthProvider } from "./contexts/auth/auth.provider";
import { SuperToastProvider } from "./components/shared/super-toast/SuperToast.provider";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SuperToastProvider>
          <BackgroundVideo />
          <div className="content">
            <Routes>
              <Route path="/" Component={RootPage} />
            </Routes>
          </div>
        </SuperToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
